import { Component, Input, OnInit, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { IChecklist } from './interfaces/checklist.interface';
import { ChecklistService } from './services/checklist.service';
import { MatDialog } from '@angular/material/dialog';
import { AbcEmpresasCustomizablesComponent } from '@p-parametria/mantenimiento/abc-empresas/components/abc-empresas-customizables/abc-empresas-customizables.component';

@Component({
  selector: 'app-checklist-form',
  templateUrl: './checklist-form.component.html',
  providers: [MessageService]
})
export class ChecklistFormComponent implements OnInit, OnChanges {
  @Input() model: IChecklist | null = null;
  @Output() onSave = new EventEmitter<{ success: boolean; message: string }>();
  form!: FormGroup;
  loading: boolean = false;

  constructor(
    private fb: FormBuilder,
    private messageService: MessageService,
    private checklistService: ChecklistService,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.initForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['model']) {
      if (changes['model'].currentValue) {
        this.form.patchValue({
          numAct: this.model?.numAct,
          descripcion: this.model?.descripcion
        });
        this.form.get('numAct')?.disable();
      } else {
        this.initForm();
      }
    }
  }

  initForm(): void {
    this.form = this.fb.group({
      numAct: [{ value: '', disabled: !!this.model }, [Validators.required]],
      descripcion: ['', [Validators.required]]
    });
  }

  create(): void {
    if (this.form.invalid) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Por favor complete todos los campos requeridos'
      });
      return;
    }

    this.loading = true;
    const formData = this.form.getRawValue();
    
    this.checklistService.saveChecklist(formData).subscribe({
      next: (response) => {
        if (response.success) {
          this.onSave.emit({ success: true, message: 'Checklist creado exitosamente' });
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: response.data.error || 'No se pudo crear el checklist'
          });
        }
        this.loading = false;
      },
      error: (error) => {
        console.error('Error al crear checklist:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Error al crear el checklist'
        });
        this.loading = false;
      }
    });
  }

  update(): void {
    if (this.form.invalid) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Por favor complete todos los campos requeridos'
      });
      return;
    }

    this.loading = true;
    const formData = this.form.getRawValue();
    
    this.checklistService.updateChecklist(formData).subscribe({
      next: (response) => {
        if (response.success) {
          this.onSave.emit({ success: true, message: 'Checklist actualizado exitosamente' });
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: response.data?.error || 'No se pudo actualizar el checklist'
          });
        }
        this.loading = false;
      },
      error: (error) => {
        console.error('Error al actualizar checklist:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Error al actualizar el checklist'
        });
        this.loading = false;
      }
    });
  }

  openCustomizables(): void {
    this.dialog.open(AbcEmpresasCustomizablesComponent, {
      width: '1000px',
      height: '1000px',
      disableClose: true,
      panelClass: ['custom-dialog-zindex'],
      hasBackdrop: true,
      autoFocus: false,
      data: {
        sTabla: 'CatChkLs',
        sClave: `${this.form.get('numAct')?.value}`,
        sNombre: this.form.get('descripcion')?.value,
        sTipo: 'Opcion'
      }
    });
  }

  onDialogClosed(): void {
    this.form.reset();
    this.model = null;
  }
} 